module.exports = __webpack_public_path__ + "static/media/1017334.8e7819ed.jpg";